import { render, staticRenderFns } from "./VaimoCollectedProducts.vue?vue&type=template&id=0f95a696&scoped=true&"
import script from "./VaimoCollectedProducts.vue?vue&type=script&lang=ts&"
export * from "./VaimoCollectedProducts.vue?vue&type=script&lang=ts&"
import style0 from "./VaimoCollectedProducts.vue?vue&type=style&index=0&id=0f95a696&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f95a696",
  null
  
)

export default component.exports